import { createReducer } from 'deox';
import { produce } from 'immer';

import {
  setUserInfoData,
  clearUserError,
  getUserInfo,
  updateUserInfo,
  updateUserPassword,
  setCurrency,
  setCountry,
  getCreditCardInfo,
  createCreditCardInfo,
  deleteCreditCardInfo, getClickCountTotal, setCountryCode, getCountries,
} from './actions';
import { UserTypes } from './types';

const initialState: UserTypes = {
  loading: false,
  errors: {},
  totalClick: null,
  userInfo: {
    country: null,
    clinicName: '',
    yourPosition: '',
    fullName: '',
    phoneNumber: '',
    email: '',
    currentPassword: '',
    newPassword: '',
    passwordConfirm: '',
  },
  currencyType: null,
  currentCountry: null,
  countryCode: null,
  creditCards: [],
  countriesList: [],
};

export const userReducer = createReducer(initialState, handleAction => [
  handleAction(setUserInfoData, (state, { payload: { name, value } }) =>
    produce(state, draft => {
      draft.userInfo[name] = value;
    }),
  ),
  // GET USER INFO
  handleAction(getUserInfo.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(getUserInfo.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.userInfo.clinicName = payload.clinic_name;
      draft.userInfo.yourPosition = payload.position_title;
      draft.userInfo.phoneNumber = payload.phone_number;
      draft.userInfo.fullName = payload.full_name;
      draft.userInfo.email = payload.email;
      draft.userInfo.country = payload.country;
      draft.currencyType = payload.country && payload.country.length && payload.country[0].curr_code || 'aud'
    }),
  ),
  handleAction(getUserInfo.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // UPDATE USER INFO
  handleAction(updateUserInfo.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(updateUserInfo.success, (state, {payload}: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.userInfo.clinicName = payload.clinic_name;
      draft.userInfo.yourPosition = payload.position_title;
      draft.userInfo.phoneNumber = payload.phone_number;
      draft.userInfo.fullName = payload.full_name;
      draft.userInfo.email = payload.email;
      draft.userInfo.country = payload.country;
    }),
  ),
  handleAction(updateUserInfo.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // UPDATE USER PASSWORD
  handleAction(updateUserPassword.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(updateUserPassword.success, state =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(updateUserPassword.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // CLEAR ERROR
  handleAction(clearUserError, state =>
    produce(state, draft => {
      draft.errors = {};
    }),
  ),
  // GET CURRENCY
  handleAction(setCurrency, (state, { payload }) =>
    produce(state, draft => {
      draft.currencyType = payload;
    }),
  ),
  // SET COUNTRY
  handleAction(setCountry, (state, { payload }) =>
    produce(state, draft => {
      draft.currentCountry = payload;
    }),
  ),
  handleAction(setCountryCode, (state, { payload }) =>
    produce(state, draft => {
      draft.countryCode = payload;
    }),
  ),
  // GET CREDIT CARD INFO
  handleAction(getCreditCardInfo.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(getCreditCardInfo.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.creditCards = payload;
    }),
  ),
  handleAction(getCreditCardInfo.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // ADD CREDIT CARD INFO
  handleAction(createCreditCardInfo.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(createCreditCardInfo.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(createCreditCardInfo.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  // DELETE CREDIT CARD INFO
  handleAction(deleteCreditCardInfo.request, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = true;
      draft.errors = {};
    }),
  ),
  handleAction(deleteCreditCardInfo.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
    }),
  ),
  handleAction(deleteCreditCardInfo.fail, (state, { payload }: any) =>
    produce(state, draft => {
      draft.loading = false;
      draft.errors = payload;
    }),
  ),
  handleAction(getClickCountTotal.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.totalClick = payload;
    }),
  ),
  handleAction(getCountries.success, (state, { payload }: any) =>
    produce(state, draft => {
      draft.countriesList = payload;
    }),
  ),
]);
